export default {
  Warnings: {
    warning_farm_disabled: {
      manager_farms: 'Gerenciar haciendas',
      message_farm_disabled:
        'Esta hacienda está deshabilitada, no podrá editar ni crear nada. habilitar para usar',
    },
  },
}
